import React, { useState, useRef, useEffect } from "react"
import {
  Form,
  Alert,
  Button,
  Card,
  Modal,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap"
import { useAuth } from "../contexts/AuthContext"
import { useHistory } from "react-router-dom"
import { db, stripePromise, createStripeCheckout } from "../firebase"
import { doc, getDoc, setDoc, onSnapshot, Timestamp } from "firebase/firestore"
import { postHttp } from "../api/HttpClient"
import CenteredContainer from "./CenteredContainer"
import Image from "react-bootstrap/Image"
import DropdownButton from "react-bootstrap/DropdownButton"
import Dropdown from "react-bootstrap/Dropdown"
import { optionRegistration, optionSubscription } from "../helpers/Data"
// import EntryCode from "./EntryCode"
// import { Link } from "react-bootstrap-icons";
// import RegistrationOptions from "./RegistrationOptions";
// import { RequestMockPayment } from "./RequestMockPayment"
const CURRENT_YEAR = new Date().getFullYear()

export default function RegistrationSimplified() {
  const [error, setError] = useState("")
  const [currentCategory, setCurrentCategory] = useState("")
  const [activeQR, setActiveQR] = useState(false)
  // const [statusPendiente, setStatusPendiente] = useState("")
  const [timeLeft, setTimeLeft] = useState(0)
  const [minutesLeft, setMinutesLeft] = useState(0)
  const [expireDate, setExpireDate] = useState("")
  const { currentUser, logout, currentAdmin, currentBecario } = useAuth()
  const [loading, setLoading] = useState(true)
  const [currentProfile, setCurrentProfile] = useState({})
  const [currentSubscription, setCurrentSubscription] = useState({})
  const [visibleQr, setVisibleQr] = useState(false)
  const [verifyQR, setVerifyQR] = useState(false)
  const [responseRq, setResponseRq] = useState(null)
  const [dataSelect, setDataSelect] = useState(optionRegistration[0])
  const history = useHistory()
  const paperRef = useRef(currentProfile?.paperID)

  const [paymentTypeQR, setPaymentTypeQR] = useState(false)
  const [paymentTypePayPal, setPaymentTypePayPal] = useState(false)
  const [paymentTypeStripe, setPaymentTypeStripe] = useState(false)

  const [vegetarianOption, setVegetarianOption] = useState(false)
  const [certificateOption, setCertificateOption] = useState(true)
  const [paperID, setPaperID] = useState(true)
  const [preferencesUpdated, setPreferencesUpdated] = useState(false)
  const allowedCategories = ["Miembro"]

  const [orderData, setOrderData] = useState(null)

  // ==================================
  // Use Effects
  // ==================================

  // Hook to listen firestore in real time

  // const docRef = doc(db, "usersNew", currentUser.uid)

  // users subcollections:
  const profileRef = doc(db, "usersNew", currentUser.uid)
  const subRef = doc(
    db,
    `usersNew/${currentUser.uid}/subscriptions/${CURRENT_YEAR}`
  )

  // subscription collection
  const topLevelSubRef = doc(
    db,
    `subscriptions/${currentUser.uid}_${CURRENT_YEAR}`
  )

  useEffect(() => {
    if (!currentUser) return

    let unsubDoc

    const fetchData = async () => {
      // Listen to profile updates
      unsubDoc = onSnapshot(profileRef, async (snapshot) => {
        const profile = snapshot.data()
        setCurrentProfile(profile)
        setVegetarianOption(profile?.vegetarianOption || false)
        setCertificateOption(profile?.certificate || false)
        setPaperID(profile?.paperID || "")

        // console.log("Profile data:", profile)
        // Once profile is available, check subscription
        try {
          const subSnap = await getDoc(subRef)
          if (subSnap.exists()) {
            setCurrentSubscription(subSnap.data())
          } else {
            const defaultSubscription = {
              affiliation: profile?.Affiliation || "",
              category: "",
              certificate: false,
              email: profile?.email || "",
              expiration_date: "",
              lastPayment: "",
              name: profile?.Name + " " + profile?.Surname || "",
              paperID: "",
              paymentType: "",
              payment_id: 0,
              subscription: false,
              uid: profile?.uid,
              vegetarianOption: false,
              status: 0,
              year: CURRENT_YEAR,
            }
            await setDoc(subRef, defaultSubscription)
            await setDoc(topLevelSubRef, defaultSubscription)
            setCurrentSubscription(defaultSubscription)
          }
        } catch (err) {
          console.error(err)
          setError("Failed to fetch subscription info.")
        } finally {
          setLoading(false)
        }
      })
    }

    fetchData()

    return () => {
      if (unsubDoc) unsubDoc()
    }
  }, [])

  // console.log("currentSubscription", currentSubscription)

  // Hook to check status everytime the data on the current user changes
  useEffect(() => {
    if (currentSubscription != null) {
      ;(async () => docSnap())()
    }
  }, [currentSubscription.status])

  // ==================================
  // Functions
  //  Temp changes for testing
  // currentProfile.status = 2
  // currentProfile.subscription = true
  // currentProfile.category = "Professional"
  const [conferenceMaterial, setConferenceMaterial] = useState(true)
  // setConferenceMaterial(false)
  // currentProfile.paperID = null
  // ==================================

  // Load data
  const docSnap = async () => {
    setLoading(true)

    // Check QR status
    await checkVerify(currentSubscription)

    // Reset loading state
    setLoading(false)
  }

  // Check if user is subscribed
  const checkVerify = async (paymentData) => {
    await verifyPayment(paymentData)
  }

  // Update payment reference
  const updatePaymentReference = async (subscriptionData) => {
    try {
      // Reference to the payment document in Firestore
      const payRef = doc(
        db,
        `usersNew/${currentUser.uid}/payments/${subscriptionData.payment_id}`
      )

      // console.log("payRef", payRef)
      // console.log("Updating payment reference with data:", subscriptionData)

      // Update the payment document
      await setDoc(
        payRef,
        {
          amount: subscriptionData.amount,
          currency: "BOB",
          status: subscriptionData.status || 0, // Default to 1 if status is not provided
          method: subscriptionData.paymentType || null, // Default to "QR" if method is not provided
          payment_id: subscriptionData.payment_id,
          timestamp: Timestamp.now(), // Use Firebase Timestamp for the current time
          category: subscriptionData.category,
        },
        { merge: true } // Merge to avoid overwriting existing fields
      )
    } catch (error) {
      console.error("Error updating payment reference:", error)
      alert("Failed to update payment. Please try again.")
    }
  }

  // Payment verification
  const verifyPayment = async (paymentData) => {
    setLoading(true)

    if (paymentData?.payment_id > 0 && paymentData?.status !== 2) {
      const body = {
        order_owner: "Qr",
        payment_id: paymentData.payment_id,
      }
      const { response, success, errorData, message } = await postHttp(
        "verify",
        body
      )

      if (success) {
        if (response?.state) {
          if (response?.state === 2) {
            const subscribeEvent = response?.state === 2 ? true : false
            const paymentTimeStamp = new Date(
              Timestamp.now().toDate().toString()
            )

            const dateStampUse = new Intl.DateTimeFormat("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            }).format(paymentTimeStamp)

            const updatedSubscription = {
              ...paymentData,
              subscription: subscribeEvent,
              status: response?.state,
              lastPayment: dateStampUse,
              expiration_date: Timestamp.fromDate(
                new Date(`${new Date().getFullYear()}-12-31T23:59:59Z`)
              ), // End of year
            }

            // Update the subscription sub-collection
            await setDoc(subRef, updatedSubscription, { merge: true })
            await setDoc(topLevelSubRef, updatedSubscription, { merge: true })

            // Update the payment sub-collection
            updatePaymentReference(updatedSubscription)

            setCurrentSubscription(updatedSubscription)
            setResponseRq(response)
          } else if (response?.state === 6 || response?.state === 98) {
            // QR expired
            const updatedSubscription = {
              ...paymentData,
              subscription: false,
              payment_id: 0,
              status: 0,
            }
            // Update the subscription sub-collection
            await setDoc(subRef, updatedSubscription, { merge: true })
            await setDoc(topLevelSubRef, updatedSubscription, { merge: true })

            // Update the payment sub-collection
            updatePaymentReference(currentSubscription)

            setCurrentSubscription(updatedSubscription)
            setResponseRq(null)
          } else if (response?.state === 1) {
            // QR pending
            setResponseRq(response)
            var dt = new Date(paymentData.expiration_date)
            var caracas_datetime_str = new Date(
              paymentData.expiration_date
            ).toLocaleString("en-US", { timeZone: "America/Caracas" })
            var dtNow = new Date(caracas_datetime_str)
            var timeDiff = Math.abs(dtNow - dt)
            var hours = Math.floor(timeDiff / 3.6e6)
            var minutes = Math.floor((timeDiff % 3.6e6) / 6e4)

            setActiveQR(true)
            setTimeLeft(hours)
            setExpireDate(caracas_datetime_str)
            setMinutesLeft(minutes)
            // console.log(response)
          }
        }
      } else {
        const { code, error, state } = errorData
        alert(error)
      }
    }
    setLoading(false)
  }

  // Log out from dashboard
  async function handleLogout() {
    setError("")

    try {
      await logout()
      history.push("/login")
    } catch (error) {
      setError("Failed to log out")
    }
  }

  // Botones de informacion
  const ToolTipLink = ({ id, children, title }) => (
    <OverlayTrigger overlay={<Tooltip id={id}>{title}</Tooltip>}>
      <span className='fw-bold fi'>
        {children}{" "}
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='16'
          fill='currentColor'
          className='bi bi-info-circle'
          viewBox='0 0 20 20'
        >
          <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16' />
          <path d='m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0' />
        </svg>
      </span>
    </OverlayTrigger>
  )

  // Get price based on selection
  const getPriceByType = async () => {
    // const profesionalMembershipOnlyPrice = 100
    // const profesionalFullPrice = 250

    switch (dataSelect?.value) {
      case "Member":
        return 133
      case "Professional":
        return 320
      case "Student":
        return 180
      default:
        return 0
    }
  }

  // ===========================================
  // Function to connect with payment API
  // ===========================================
  const handleSubscribe = async (e) => {
    e.preventDefault()
    setPaymentTypePayPal(false)
    setPaymentTypeQR(false)
    setLoading(true)
    setError()
    if (currentSubscription?.uid && dataSelect?.value !== "select") {
      const category = dataSelect?.value
      const price = await getPriceByType()
      const body = {
        order_owner: "BCDE2025",
        provider_uid: "Ic5wEhQv2XX6zKvoJ6VZXrSc6c42",
        quantity: 1,
        customer_id: currentSubscription?.uid,
        first_name: currentSubscription?.name,
        email: currentSubscription?.email,
        mobile: "5235235423",
        provider_id: "5235235423",
        provider_name: "SEBOL",
        provider_email: "pcubaborda@gmail.com",
        amount: price,
        discount: 0,
        shippin: 0,
        tax: 0,
        items: [],
        total: price,
        order_code: "qr-evento",
        date_schedule: new Date(),
        client_code: "qua",
        concept: `: Membresia SEBOL 2025`,
        description: "SEBOL 2025",
        payment_id: 0,
        category: category,
      }

      // Send payment request to the API
      const { response, success, error, status } = await postHttp(
        "payment",
        body
      )

      // Process payment request
      if (success) {
        // console.log("response", response)
        await updatePayment(response, category)
      }
    } else {
      setError("Selecciona una opción")
    }
    setLoading(false)
  }

  // ================================================
  // Function to update payment information
  // ================================================
  const updatePayment = async (responseData, category) => {
    const profileNew = {
      ...currentSubscription,
      payment_id: responseData?.payment_id ? responseData?.payment_id : 0,
      status: 1,
      // expiration_date: responseData.expiration_date,
      category: category,
      paymentType: "QR",
      amount: responseData.total,
    }

    // console.log("update Payment data:", profileNew)
    // Update the subscription sub-collection
    await setDoc(subRef, profileNew)
    await setDoc(topLevelSubRef, profileNew, { merge: true })

    // update the payment subcollection
    updatePaymentReference(profileNew)

    setCurrentSubscription(profileNew)
    setResponseRq(responseData)
    setCurrentCategory(category)

    // Calculate time left for QR expiration
    var caracas_datetime_str = new Date(
      responseData.expiration_date
    ).toLocaleString("en-US", { timeZone: "America/Caracas" })
    setExpireDate(caracas_datetime_str)

    setVisibleQr(true)
  }

  // Verify QR
  const handleVerifyQr = async (e) => {
    e.preventDefault()
    if (currentSubscription?.uid) {
      await verifyPayment(currentSubscription)
    }
    setVerifyQR(true)
  }

  // Spinner
  const LoadSpinner = () => {
    return (
      <>
        {loading && (
          <div className={"d-flex justify-content-center"}>
            <Spinner animation='border' role='status'>
              <span className='visually-hidden'> Loading...</span>
            </Spinner>
          </div>
        )}
      </>
    )
  }

  // Function to update Profile
  async function updateProfile(newProfileData) {
    const data = newProfileData
    try {
      await setDoc(subRef, data, { merge: true })
      await setDoc(topLevelSubRef, data, { merge: true })
    } catch (err) {
      console.log(err)
    }
  }

  // // Function to redirect to external URL
  // async function redirectToExternalURL(e) {
  //   e.preventDefault()
  //   // const promises = []
  //   setPaymentTypePayPal(false)
  //   setPaymentTypeQR(false)

  //   setLoading(true)
  //   setError("")

  //   let newProfileData = {}

  //   // Paper ref
  //   newProfileData.paymentType = "PayPal"
  //   newProfileData.status = 10
  //   LoadSpinner()
  //   try {
  //     // console.log(newProfileData);
  //     await updateProfile(newProfileData)
  //   } catch (err) {
  //     console.log("Error handling PayPal redirect")
  //     console.log(err)
  //   }

  //   setLoading(false)

  //   window.open("https://www.paypal.com/paypalme/SEBOLBCDE", "_blank") // Opens in a new window/tab
  // }

  // Submit changes to Conference options
  async function handleConferenceOptions(e) {
    e.preventDefault()

    setLoading(true)
    setError("")

    let newProfileData = {}

    newProfileData.paperID = paperID
    newProfileData.vegetarianOption = vegetarianOption
    newProfileData.certificate = certificateOption

    LoadSpinner()
    try {
      await updateProfile(newProfileData)
    } catch (err) {
      console.log("Error handling conference options", err.message)
    }
    setPreferencesUpdated(true)
    setLoading(false)
  }

  // =================================================
  // Set type of payment to display payments card
  // =================================================
  function handlePaymentQR(e) {
    e.preventDefault()
    setPaymentTypePayPal(false)
    setPaymentTypeStripe(false)
    setPaymentTypeQR(!paymentTypeQR)
  }

  // =================================================
  // Set type of payment to display payments card
  // =================================================
  function handlePaymentStripe(e) {
    e.preventDefault()
    setPaymentTypeQR(false)
    setPaymentTypePayPal(false)
    setPaymentTypeStripe(!paymentTypeStripe)
  }

  // QR status
  const showStatusQr = () => {
    if (currentSubscription.subscription === false) {
      switch (currentSubscription.status) {
        case 1:
          return (
            <div>
              <Alert variant='warning'>
                <div className='text-center'>
                  <div className='fs-5'>
                    Pago Pendiente
                    <p className='fs-6'>
                      {" "}
                      Por favor pague el siguiente código QR usando su
                      aplicación de banca móvil
                    </p>
                    <hr className='hr-danger' />
                  </div>

                  {currentSubscription?.category && (
                    <div>
                      Categoria:
                      <p className=' text-success text-center'>
                        {currentSubscription.category}
                      </p>
                    </div>
                  )}
                  {activeQR === true && (
                    <div>
                      <div className='d-flex justify-content-center'>
                        <img
                          src={`data:image;base64,${responseRq?.qr}`}
                          alt='Qr'
                        />
                      </div>
                      <hr className='hr-danger' />
                      Código QR expira en:
                      <div className='text-danger text-center'>
                        {responseRq?.expiration_date}
                      </div>
                    </div>
                  )}
                </div>
              </Alert>
            </div>
          )

        case 3:
          return "Rechazado"
        case 4:
          return "Error"
        case 5:
          return "Revertido"
        case 6:
          return "Vencido"
        case 98:
          return "Eliminado"

        default:
          return ""
      }
    } else {
      return (
        <>
          <Alert variant='success'>
            <div className='text-center'>
              <h4> Inscripción exitosa </h4>
              <p> Successful registration </p>

              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='40'
                height='40'
                fill='currentColor'
                className='bi bi-check-circle'
                viewBox='0 0 16 16'
              >
                <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />
                <path d='M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z' />
              </svg>
              <div className='fs-5 mt-3'>
                Categoria: {currentSubscription.category}
              </div>
            </div>
          </Alert>

          {/* Conference Preferences */}
          {allowedCategories.includes(currentSubscription.category) ? (
            <>
              <h4 className='mt-4 text-center'>
                Preferencias para la Conferencia
              </h4>
              <p className='text-center fs-6 text-secondary'>
                {" "}
                Your Conference Preferences
              </p>{" "}
              {preferencesUpdated && (
                <Alert
                  variant='info'
                  className='text-center'
                  style={{ fontSize: "0.80rem" }}
                >
                  Tus preferencias fueron actualizadas. <br /> Your preferences
                  have been updated.
                </Alert>
              )}
              <Form onSubmit={handleConferenceOptions}>
                {currentSubscription.category === "Expositor" && (
                  <Form.Group id='paperID' className='mt-1'>
                    <Form.Label column xs={12}>
                      <strong>Paper ID (opcional)</strong>
                      <div
                        className='text-justified'
                        style={{ fontSize: "0.80rem" }}
                      >
                        Incluye el Conference Maker ID de tu documento.{" "}
                        <ToolTipLink
                          title='Puedes encontrar tu paper ID en el email de aceptación o en tu cuenta de conference maker'
                          id='t-1'
                          className='fs-1'
                        />
                      </div>
                      <div
                        className='text-secondary mt-0 text-justified'
                        style={{ fontSize: "0.8rem" }}
                      >
                        Please include your paper's Conference Maker ID.
                        <ToolTipLink
                          title='You can find your paper ID in the acceptance email or in your conference maker dashboard'
                          id='t-1'
                          className='fs-1'
                        />
                      </div>
                    </Form.Label>
                    <Form.Control
                      type='text'
                      placeholder='Conference Maker Paper ID'
                      // value={currentProfile?.paperID || ''}
                      // ref={paperRef}
                      value={paperID}
                      onChange={(e) => setPaperID(e.target.value)}
                      size='sm'
                    />
                  </Form.Group>
                )}
                {/* Vegetarian Dinner Option */}
                <Form.Label column xs={12} className='mt-2'>
                  <strong>Opciones alimenticias</strong>
                  <div
                    className='text-justified'
                    style={{ fontSize: "0.80rem" }}
                  >
                    Opción vegetariana para comidas de la conferencia.
                  </div>
                  <div
                    className='text-secondary mt-0 text-justified'
                    style={{ fontSize: "0.8rem" }}
                  >
                    Vegetarian option for the conference meals.
                  </div>
                </Form.Label>
                <Form.Group className='mt-1'>
                  <Form.Check
                    type='checkbox'
                    id='vegetarianDinner'
                    label={
                      <div>
                        <span style={{ fontSize: "0.8rem" }}>
                          Opción vegetariana |{" "}
                        </span>
                        <span
                          className='text-secondary'
                          style={{ fontSize: "0.8rem" }}
                        >
                          Vegetarian option
                        </span>
                      </div>
                    }
                    checked={vegetarianOption}
                    onChange={(e) => setVegetarianOption(e.target.checked)}
                  />
                </Form.Group>

                {/* Opt-out of Conference Certificate */}
                <Form.Label column xs={12} className='mt-2'>
                  <strong>Certificado de participación</strong>
                  <div
                    className='text-justified'
                    style={{ fontSize: "0.80rem" }}
                  >
                    Puedes elegir recibir tu certificado de participación.
                  </div>
                  <div
                    className='text-secondary mt-0 text-justified'
                    style={{ fontSize: "0.8rem" }}
                  >
                    You may choose to receive an attendance certificate.
                  </div>
                </Form.Label>

                <Form.Group className='mt-1'>
                  <Form.Check
                    type='checkbox'
                    id='optOutCertificate'
                    label={
                      <div>
                        <span style={{ fontSize: "0.8rem" }}>
                          Recibir certificado |{" "}
                        </span>
                        <span
                          className='text-secondary'
                          style={{ fontSize: "0.8rem" }}
                        >
                          Get a certificate{" "}
                        </span>
                      </div>
                    }
                    checked={certificateOption}
                    onChange={(e) => setCertificateOption(e.target.checked)}
                  />
                </Form.Group>
                <p
                  className='mt-4 text-secondary'
                  style={{ fontSize: "0.9rem" }}
                >
                  No te olvides guardar tus preferencias | Do not forget to save
                  your preferences{" "}
                </p>
                <Button
                  disabled={loading}
                  className='w-100 mt-0
                '
                  type='submit'
                >
                  Guardar | Save
                </Button>
              </Form>
            </>
          ) : (
            <>
              <h4 className='mt-4 text-center'>
                Preferencias para la Conferencia
              </h4>
              <p className='text-center fs-6 text-secondary'>
                {" "}
                Your Conference Preferences
              </p>{" "}
              {preferencesUpdated && (
                <Alert
                  variant='info'
                  className='text-center'
                  style={{ fontSize: "0.80rem" }}
                >
                  Tus preferencias fueron actualizadas. <br /> Your preferences
                  have been updated.
                </Alert>
              )}
              <Form onSubmit={handleConferenceOptions}>
                <Form.Label column xs={12} className='mt-2'>
                  <strong>Certificado de participación</strong>
                  <div
                    className='text-justified'
                    style={{ fontSize: "0.80rem" }}
                  >
                    Puedes elegir recibir tu certificado de participación.
                  </div>
                  <div
                    className='text-secondary mt-0 text-justified'
                    style={{ fontSize: "0.8rem" }}
                  >
                    You may choose to receive an attendance certificate.
                  </div>
                </Form.Label>

                <Form.Group className='mt-1'>
                  <Form.Check
                    type='checkbox'
                    id='optOutCertificate'
                    label={
                      <div>
                        <span style={{ fontSize: "0.8rem" }}>
                          Recibir certificado |{" "}
                        </span>
                        <span
                          className='text-secondary'
                          style={{ fontSize: "0.8rem" }}
                        >
                          Get a certificate{" "}
                        </span>
                      </div>
                    }
                    checked={certificateOption}
                    onChange={(e) => setCertificateOption(e.target.checked)}
                  />
                </Form.Group>
                <p
                  className='mt-4 text-secondary'
                  style={{ fontSize: "0.9rem" }}
                >
                  No te olvides guardar tus preferencias | Do not forget to save
                  your preferences{" "}
                </p>
                <Button
                  disabled={loading}
                  className='w-100 mt-0
                '
                  type='submit'
                >
                  Guardar | Save
                </Button>
              </Form>
            </>
          )}

          {/* <EntryCode currentProfile={currentProfile} /> */}
        </>
      )
    }
  }

  // Registration section
  const showActionSubscribe = () => {
    const isPending = currentSubscription?.status === 0
    if (isPending) {
      return (
        <>
          <div className='w-100 text-center mt-2'>
            <DropdownButton
              title={dataSelect.label}
              id='dropdown-menu-align-right'
              onSelect={handleSelect}
            >
              {optionRegistration.map((item, index) => (
                <Dropdown.Item
                  key={index}
                  eventKey={item.value}
                  active={dataSelect?.value === item.value}
                >
                  {item.label}
                </Dropdown.Item>
              ))}
            </DropdownButton>
          </div>
          <div className='mt-4 mb-4'>
            {dataSelect?.value !== "select" && showData()}
          </div>{" "}
        </>
      )
    }

    switch (currentSubscription.status) {
      case 1:
        return (
          <div className={"d-flex justify-content-around w-100"}>
            <Button
              className={"w-50 m-1"}
              variant='secondary'
              onClick={() => handleDownload()}
            >
              Descargar
            </Button>
            <Button
              className={"w-50 m-1"}
              variant='success'
              onClick={handleVerifyQr}
            >
              Verificar Pago
            </Button>
          </div>
        )
      case 2:
        return <></> // e.g. fully paid or completed
      default:
        return <></>
    }
  }

  //  Handle Stripe Payments
  const handleStripePayment = async () => {
    // e.preventDefault();
    setLoading(true)
    try {
      // Await the Stripe instance
      const stripe = await stripePromise

      // Get the USD amount based on category
      let usdAmount = 48 // Default for Expositor
      if (currentSubscription.category === "Member") {
        usdAmount = 15
      } else if (currentSubscription.category === "Expositor") {
        usdAmount = 46
      }

      // Call your function to create a Stripe Checkout session with category and amount
      const response = await createStripeCheckout({
        category: currentSubscription.category,
        amount: usdAmount,
      })
      const sessionId = response.data.id

      // Redirect to Stripe Checkout
      const result = await stripe.redirectToCheckout({ sessionId })

      if (result.error) {
        // Handle any errors that may occur during the redirect
        console.error(result.error.message)
      }
    } catch (error) {
      // Handle any errors that occur during the checkout session creation
      console.error("Error during Stripe checkout:", error)
    }
    setLoading(false)
  }

  // // PayPal Show Function
  const showPaymentsCard = () => {
    if (currentSubscription.subscription === false) {
      if (paymentTypePayPal === true) {
        return (
          <Card className='mt-1'>
            <Card.Body className='text-center'>
              <h3>
                Pagar con PayPal (en $US) solo para usuarios en el exterior
              </h3>

              <p>
                {" "}
                Haz click en el siguiente botón para pagar tu inscripción usando
                PayPal. En la descripción incluye "BCDE15" y el número de
                confirmación de tu documento.
              </p>

              <span className='text-secondary fs-4'>
                {" "}
                Pay with PayPal (in $US)
              </span>

              <p className='text-secondary fs-9'>
                {" "}
                Use the button below to pay your registration through PayPal. In
                the description include "BCDE15" and your paper confirmation
                number.
              </p>

              {/* <Button variant='warning' onClick={redirectToExternalURL}>
                PayPal.Me/SEBOLBCDE
              </Button> */}
              <div></div>
            </Card.Body>
          </Card>
        )
      } else if (paymentTypeStripe === true) {
        return (
          <Card className='mt-1'>
            <Card.Body className='text-center'>
              <h3>
                Pagar con Tarjeta de Crédito (en $US) solo para participantes
                fuera de Bolivia
              </h3>

              <p style={{ fontSize: "0.75rem" }}>
                {" "}
                Su extracto bancario reflejará el pago a nombre de Rapireservas
                (Tunari LLC).
              </p>

              <span className='text-secondary fs-4'>
                {" "}
                Pay with Credit Card (in $US) only for participants living
                outside of Bolivia.
              </span>

              <p className='text-secondary' style={{ fontSize: "0.75rem" }}>
                {" "}
                You will see a charge to Rapireservas (Tunari LLC) in your card
                statement.
              </p>

              {LoadSpinner()}
              <Button
                variant='info'
                style={{
                  backgroundColor: "#ff6600",
                  borderColor: "#ff6600",
                  color: "white",
                }}
                onClick={handleStripePayment}
                disabled={loading}
              >
                Pagar | Pay
              </Button>
              <div></div>
            </Card.Body>
          </Card>
        )
      } else if (paymentTypeQR === true) {
        return (
          <Card className='mt-1'>
            <Card.Body className='text-center'>
              <h3>Pagar con QR (en bolivianos)</h3>
              <p>
                {" "}
                Solo para usuarios de bancos Bolivianos que permitan realizar
                pagos QR
              </p>

              <span className='text-secondary fs-4'>
                {" "}
                QR payment (in bolivian pesos)
              </span>

              <p className='text-secondary fs-9'>
                {" "}
                Just for users of Bolivian banks that support QR payments
              </p>
              <div>
                {/* <Alert variant='danger'>Registration Is Closed</Alert> */}
                <Button
                  variant='success'
                  disabled={loading}
                  className='w-100 mt-4'
                  style={{
                    backgroundColor: "#002266",
                    borderColor: "#002266",
                    color: "white",
                  }}
                  type='submit'
                  onClick={handleSubscribe}
                >
                  Pagar | Pay
                </Button>
              </div>
            </Card.Body>
          </Card>
        )
      }
    }
    return null
  }

  //  SHOW WHAT IS INCLUDED
  const showData = () => {
    switch (currentSubscription?.category) {
      case "Member":
        return (
          <>
            <h3 className='text-center'>
              133 Bs | <span className='text-secondary'>15 $US</span>
            </h3>
            <hr className='hr-danger' />
            <h2 className='mt-4 text-center'>Incluye con tu pago</h2>
            <p className='mt-4 fs-6 text-secondary text-center'>
              Included in your payment
            </p>
            <ul className='mx-1'>
              <li>
                Membresia 2025 SEBOL <br />
                <span className='text-secondary fs-9'>
                  2025 SEBOL membership
                </span>
              </li>
            </ul>

            <Button
              disabled={loading}
              variant='success'
              className='w-100 mt-4 p-1'
              onClick={handlePaymentQR}
            >
              Pagar con código QR | Pay with QR code{" "}
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                fill='currentColor'
                className='bi bi-qr-code'
                viewBox='0 0 18 18'
              >
                <path d='M2 2h2v2H2z' />
                <path d='M6 0v6H0V0zM5 1H1v4h4zM4 12H2v2h2z' />
                <path d='M6 10v6H0v-6zm-5 1v4h4v-4zm11-9h2v2h-2z' />
                <path d='M10 0v6h6V0zm5 1v4h-4V1zM8 1V0h1v2H8v2H7V1zm0 5V4h1v2zM6 8V7h1V6h1v2h1V7h5v1h-4v1H7V8zm0 0v1H2V8H1v1H0V7h3v1zm10 1h-1V7h1zm-1 0h-1v2h2v-1h-1zm-4 0h2v1h-1v1h-1zm2 3v-1h-1v1h-1v1H9v1h3v-2zm0 0h3v1h-2v1h-1zm-4-1v1h1v-2H7v1z' />
                <path d='M7 12h1v3h4v1H7zm9 2v2h-3v-1h2v-1z' />
              </svg>
            </Button>

            <Button
              variant='info'
              className='w-100 mt-2 p-1'
              style={{
                backgroundColor: "#ff6600",
                borderColor: "#ff6600",
                color: "white",
              }}
              onClick={handlePaymentStripe}
            >
              Pagar con Tarjeta | Pay with Credit Card{" "}
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                fill='currentColor'
                className='bi bi-credit-card'
                viewBox='0 0 18 18'
              >
                <path d='M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z' />
                <path d='M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z' />
              </svg>
            </Button>
          </>
        )

      case "Expositor":
        return (
          <>
            <h3 className='text-center'>
              320 Bs | <span className='text-secondary'>46 $US</span>
            </h3>
            <hr className='hr-danger' />
            <h2 className='mt-4 text-center'>Incluye con tu inscripción</h2>
            <p className='mt-4 fs-6 text-secondary text-center'>
              Included in your registration
            </p>
            <ul className='mx-1'>
              {/* <li>
                Almuerzo <br />{" "}
                <span className='text-secondary fs-9'> Lunch</span>
              </li> */}
              <li>
                Café y refrigerios <br />{" "}
                <span className='text-secondary fs-9'> Coffee and snacks</span>
              </li>
              <li>
                Cena para expositores <br />{" "}
                <span className='text-secondary fs-9'> Conference dinner</span>
              </li>
              <li>
                Material de conferencia <br />{" "}
                <span className='text-secondary fs-9'>
                  {" "}
                  Conference material
                </span>
              </li>
              <li>
                Certificado de participación <br />{" "}
                <span className='text-secondary fs-9'>
                  {" "}
                  Certificate of attendance
                </span>
              </li>
              <li>
                Membresia 2025 SEBOL <br />
                <span className='text-secondary fs-9'>
                  {" "}
                  2025 SEBOL membership
                </span>
              </li>
            </ul>
            {/* <Alert className='text-center'>
              <p>Presenter Registration is Closed. </p>
              <p>
                Please contact{" "}
                <a href='mailto:bcde14@sebol.org'>bcde14@sebol.org</a> if you
                missed the registration deadline.
              </p>
            </Alert> */}
            <Button
              disabled={loading}
              variant='success'
              className='w-100 mt-4 p-1'
              style={{
                backgroundColor: "#002266",
                borderColor: "#002266",
                color: "white",
              }}
              onClick={handlePaymentQR}
            >
              Pagar con código QR | Pay with QR code{" "}
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                fill='currentColor'
                className='bi bi-qr-code'
                viewBox='0 0 18 18'
              >
                <path d='M2 2h2v2H2z' />
                <path d='M6 0v6H0V0zM5 1H1v4h4zM4 12H2v2h2z' />
                <path d='M6 10v6H0v-6zm-5 1v4h4v-4zm11-9h2v2h-2z' />
                <path d='M10 0v6h6V0zm5 1v4h-4V1zM8 1V0h1v2H8v2H7V1zm0 5V4h1v2zM6 8V7h1V6h1v2h1V7h5v1h-4v1H7V8zm0 0v1H2V8H1v1H0V7h3v1zm10 1h-1V7h1zm-1 0h-1v2h2v-1h-1zm-4 0h2v1h-1v1h-1zm2 3v-1h-1v1h-1v1H9v1h3v-2zm0 0h3v1h-2v1h-1zm-4-1v1h1v-2H7v1z' />
                <path d='M7 12h1v3h4v1H7zm9 2v2h-3v-1h2v-1z' />
              </svg>
            </Button>

            <Button
              variant='info'
              className='w-100 mt-2 p-1'
              style={{
                backgroundColor: "#ff6600",
                borderColor: "#ff6600",
                color: "white",
              }}
              onClick={handlePaymentStripe}
              // onClick={() => handleStripePayment()}
            >
              Pagar con Tarjeta | Pay with Credit Card{" "}
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                fill='currentColor'
                className='bi bi-credit-card'
                viewBox='0 0 18 18'
              >
                <path d='M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z' />
                <path d='M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z' />
              </svg>
            </Button>
          </>
        )

      case "Student":
        return (
          <>
            <h3 className='text-center'>180 Bs</h3>
            <hr className='hr-danger' />
            <h2 className='mt-4 text-center'>Incluye con tu inscripción</h2>
            <p className='mt-4 fs-6 text-secondary text-center'>
              Included in your registration
            </p>
            <ul className='mx-1'>
              <li>
                Café y refrigerios <br />{" "}
                <span className='text-secondary fs-9'> Coffee and snacks</span>
              </li>
              <li>
                Material de conferencia <br />{" "}
                <span className='text-secondary fs-9'>
                  {" "}
                  Conference material
                </span>
              </li>
              <li>
                Certificado de participación <br />{" "}
                <span className='text-secondary fs-9'>
                  {" "}
                  Certificate of attendance
                </span>
              </li>
              <li>
                Membresia Estudiante 2025 SEBOL <br />
                <span className='text-secondary fs-9'>
                  {" "}
                  2025 SEBOL student membership
                </span>
              </li>
            </ul>

            <Button
              disabled={loading}
              variant='success'
              className='w-100 mt-4 p-1'
              onClick={handlePaymentQR}
            >
              Pagar con codigo QR | Pay with QR code
            </Button>
          </>
        )

      case "Professional":
        return (
          <>
            <h3 className='text-center'>
              320 Bs | <span className='text-secondary'>46 $US</span>
            </h3>
            <hr className='hr-danger' />
            <h2 className='mt-4 text-center'>Incluye con tu inscripción</h2>
            <p className='mt-4 fs-6 text-secondary text-center'>
              Included in your registration
            </p>
            <ul className='mx-1'>
              <li>
                Café y refrigerios <br />{" "}
                <span className='text-secondary fs-9'> Coffee and snacks</span>
              </li>
              <li>
                Material de conferencia <br />{" "}
                <span className='text-secondary fs-9'>
                  {" "}
                  Conference material
                </span>
              </li>
              <li>
                Certificado de participación <br />{" "}
                <span className='text-secondary fs-9'>
                  {" "}
                  Certificate of attendance
                </span>
              </li>
              <li>
                Membresia 2025 SEBOL <br />
                <span className='text-secondary fs-9'>
                  {" "}
                  2025 SEBOL membership
                </span>
              </li>
            </ul>

            <Button
              disabled={loading}
              variant='success'
              className='w-100 mt-4 p-1'
              onClick={handlePaymentQR}
            >
              Pagar con código QR | Pay with QR code{" "}
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                fill='currentColor'
                className='bi bi-qr-code'
                viewBox='0 0 18 18'
              >
                <path d='M2 2h2v2H2z' />
                <path d='M6 0v6H0V0zM5 1H1v4h4zM4 12H2v2h2z' />
                <path d='M6 10v6H0v-6zm-5 1v4h4v-4zm11-9h2v2h-2z' />
                <path d='M10 0v6h6V0zm5 1v4h-4V1zM8 1V0h1v2H8v2H7V1zm0 5V4h1v2zM6 8V7h1V6h1v2h1V7h5v1h-4v1H7V8zm0 0v1H2V8H1v1H0V7h3v1zm10 1h-1V7h1zm-1 0h-1v2h2v-1h-1zm-4 0h2v1h-1v1h-1zm2 3v-1h-1v1h-1v1H9v1h3v-2zm0 0h3v1h-2v1h-1zm-4-1v1h1v-2H7v1z' />
                <path d='M7 12h1v3h4v1H7zm9 2v2h-3v-1h2v-1z' />
              </svg>
            </Button>

            <Button
              variant='info'
              className='w-100 mt-2 p-1'
              style={{
                backgroundColor: "#ff6600",
                borderColor: "#ff6600",
                color: "white",
              }}
              onClick={handlePaymentStripe}
            >
              Pagar con Tarjeta | Pay with Credit Card{" "}
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                fill='currentColor'
                className='bi bi-credit-card'
                viewBox='0 0 18 18'
              >
                <path d='M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z' />
                <path d='M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z' />
              </svg>
            </Button>
          </>
        )

      default:
        return <></>
    }
  }

  // Function to download QR code
  const handleDownload = () => {
    if (responseRq) {
      const fileName = "Qr_order_" + Date.now().toString()
      const source = `data:application/jpg;base64,${responseRq.qr}`
      const link = document.createElement("a")
      link.href = source
      link.download = `${fileName}.jpg`
      link.click()
    }
  }

  // Function to select registration options
  const handleSelect = (e) => {
    // console.log("currentProfile:", currentProfile)
    const ds = optionRegistration.find((item) => item.value === e)
    setDataSelect(ds)
    // console.log("Selected option:", ds)
    const profileNew = { ...currentSubscription, category: ds.value }
    // console.log("Current Subscription:", profileNew)

    setCurrentSubscription(profileNew)
  }

  // ======================================
  // Check Status
  // ======================================
  // console.log("Current Profile:", currentProfile)
  let fullName = currentProfile.Name + " " + currentProfile.Surname

  const today = new Date()

  const lastPaymentDate = currentProfile.lastPayment
    ? new Date(currentProfile.lastPayment)
    : null

  const expirationDate = lastPaymentDate ? new Date(lastPaymentDate) : null

  if (expirationDate !== null && !isNaN(expirationDate)) {
    // Add one year to the expirationDate
    expirationDate.setFullYear(expirationDate.getFullYear() + 1)
  }
  // console.log("Current User:", currentUser)

  // =======================================
  // HTML BEGINS HERE
  // =======================================
  return (
    <CenteredContainer>
      <Card className='position-relative'>
        <div
          className='position-absolute w-100 text-center'
          style={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            zIndex: 2,
          }}
        >
          <h1 className='pink'>
            <span
              className='text-white'
              style={{ fontWeight: 800, fontSize: "2rem" }}
            >
              SEBOL
              <br />
              ANNUAL MEMBERSHIP <br />
              2025
            </span>
          </h1>
        </div>
        <Image
          src={require("../images/portada2025.jpg")}
          rounded
          className='w-100'
          style={{
            filter: "brightness(0.7)",
            height: "300px", // Set the height to reduce the image size
            objectFit: "cover", // Ensure the image scales properly without distortion
          }} // Optional: Darken the image for better text visibility
        />
      </Card>
      {/* Card: Mis Datos */}
      {
        <Card className='mt-1'>
          {LoadSpinner()}

          <Card.Body className='mt-2 p-4'>
            <h2 className='text-center mb-2'>Mis Datos</h2>
            <p className='text-center fs-6 text-secondary'> My Profile</p>
            {currentUser && currentUser.photoURL && (
              <Image
                src={currentUser.photoURL}
                roundedCircle
                className='mx-auto d-block'
                style={{ maxWidth: "40px" }}
              />
            )}
            <hr className='hr-danger' />
            {!loading && (
              <>
                <div className='p-1 d-flex flex-row justify-content-between'>
                  <div>
                    Nombre completo:
                    <div className='text-secondary'>Full name</div>
                  </div>
                  <div>{fullName}</div>
                </div>

                <div className='p-1 d-flex flex-row justify-content-between'>
                  <div>
                    Institución:
                    <div className='text-secondary'>Affiliation</div>
                  </div>
                  <div>{currentProfile.Affiliation}</div>
                </div>

                <div className='p-1 d-flex flex-row justify-content-between'>
                  <div>
                    Título académico:
                    <div className='text-secondary'>Academic degree</div>
                  </div>
                  <div>{currentProfile.Degree}</div>
                </div>

                <div className='p-1 d-flex flex-row justify-content-between'>
                  <div>
                    Ocupación:
                    <div className='text-secondary'>Occupation</div>
                  </div>
                  <div>{currentProfile.occupation}</div>
                </div>

                <div className='p-1 d-flex flex-row justify-content-between'>
                  <div>
                    Correo electrónico:
                    <div className='text-secondary'>Email</div>
                  </div>
                  <div>{currentProfile.email}</div>
                </div>

                <hr className='hr-danger' />

                <div className='w-100 text-center mt-2'>
                  <Button
                    variant='link'
                    className='w-100 mt-2'
                    onClick={() => history.push("/update")}
                  >
                    Actualizar datos | Update profile
                  </Button>

                  {currentAdmin && (
                    <Button
                      variant='warning'
                      className='w-50 mt-2'
                      onClick={() => history.push("/admin")}
                    >
                      Panel de administrador
                    </Button>
                  )}
                </div>
              </>
            )}
          </Card.Body>
        </Card>
      }

      {/* BCDE REGISTRATION  */}
      {!loading && (
        <Card className='mt-1'>
          <Card.Body>
            <>
              <h2 className='text-center mb-4 mt-2 '>Inscripción SEBOL</h2>
              <p className='text-center fs-6 text-secondary'>
                {" "}
                BCDE registration
              </p>
              {error && <Alert variant='danger'>{error}</Alert>}

              {showStatusQr()}

              {showActionSubscribe()}
            </>
          </Card.Body>
        </Card>
      )}

      {showPaymentsCard()}

      {/* ========= Footer =============== */}

      <Card className='mt-1'>
        <div className='text-center'>
          <p className='text-center text-secondary mt-2'>
            {" "}
            Questions? <a href='mailto:admin@sebol.org'> Email us</a>
          </p>
        </div>
        <div>
          <p className='text-center text-secondary mt-2'> Powered by:</p>
          <Image
            src={require("../images/LogoRapiReservas.png")}
            rounded
            className='mx-auto d-block'
            style={{ maxWidth: "80px" }}
          ></Image>
        </div>
      </Card>

      {/* ========= Log out =============== */}

      <div className='w-100 text-center'>
        <Button
          className='w-50 mt-1 text-danger'
          variant='link'
          onClick={handleLogout}
        >
          Salir | Log out
        </Button>
      </div>
    </CenteredContainer>
  )
}
